export default __webpack_public_path__ + "static/media/mariog16.d51da342.jpg";